export default __webpack_public_path__ + "static/media/logo_v1_h_ob.18a79bd1.svg";